import { createV3Queries } from "@query/utils/createV3Queries";
import { payerEngagementsApi } from "@api";

/**
 * Payer-engagement (relationship) registry — mirrors `PayerEngagementsApi` 1:1.
 * The v3 twin of the v1 `getPayerEngagements` service the assignment pickers
 * relied on: after a new client is created, `listPayerEngagements({ payerId })`
 * resolves the freshly-created engagement so the picker can select it. The
 * name-derived defaults cover sibling read invalidation; no cross-resource
 * config is needed yet.
 */
export const queriesPayerEngagements = createV3Queries(
  "payerEngagementsApi",
  payerEngagementsApi
);
